class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');

    if (facetForm) {
      facetForm.addEventListener(
        'input',
        this.debouncedOnSubmit.bind(this)
      );
    }

    const facetWrapper = this.querySelector(
      '#FacetsWrapperDesktop'
    );

    if (facetWrapper) {
      facetWrapper.addEventListener(
        'keyup',
        onKeyUpEscape
      );
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;

      if (
        searchParams ===
        FacetFiltersForm.searchParamsPrev
      ) {
        return;
      }

      FacetFiltersForm.renderPage(
        searchParams,
        null,
        false
      );
    };

    window.addEventListener(
      'popstate',
      onHistoryChange
    );
  }

  static toggleActiveFacets(
    disable = true
  ) {
    document
      .querySelectorAll(
        '.js-facet-remove'
      )
      .forEach((element) => {
        element.classList.toggle(
          'disabled',
          disable
        );
      });
  }

  static renderPage(
    searchParams,
    event,
    updateURLHash = true
  ) {
    FacetFiltersForm.searchParamsPrev =
      searchParams;

    const sections =
      FacetFiltersForm.getSections();

    const countContainer =
      document.getElementById(
        'ProductCount'
      );

    const countContainerDesktop =
      document.getElementById(
        'ProductCountDesktop'
      );

    const productGridContainer =
      document.getElementById(
        'ProductGridContainer'
      );

    const collection =
      productGridContainer?.querySelector(
        '.collection'
      );

    if (collection) {
      collection.classList.add(
        'loading'
      );
    }

    if (countContainer) {
      countContainer.classList.add(
        'loading'
      );
    }

    if (countContainerDesktop) {
      countContainerDesktop.classList.add(
        'loading'
      );
    }

    sections.forEach((section) => {
      const url =
        `${window.location.pathname}` +
        `?section_id=${section.section}` +
        `&${searchParams}`;

      const filterDataUrl =
        (element) =>
          element.url === url;

      FacetFiltersForm.filterData.some(
        filterDataUrl
      )
        ? FacetFiltersForm.renderSectionFromCache(
            filterDataUrl,
            event
          )
        : FacetFiltersForm.renderSectionFromFetch(
            url,
            event
          );
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(
        searchParams
      );
    }
  }

  static renderSectionFromFetch(
    url,
    event
  ) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Facet request failed: ${response.status}`
          );
        }

        return response.text();
      })
      .then((responseText) => {
        const html =
          responseText;

        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          {
            html,
            url
          }
        ];

        FacetFiltersForm.renderFilters(
          html,
          event
        );

        FacetFiltersForm.renderProductGridContainer(
          html
        );

        FacetFiltersForm.renderProductCount(
          html
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static renderSectionFromCache(
    filterDataUrl,
    event
  ) {
    const cached =
      FacetFiltersForm.filterData.find(
        filterDataUrl
      );

    if (!cached) return;

    const html =
      cached.html;

    FacetFiltersForm.renderFilters(
      html,
      event
    );

    FacetFiltersForm.renderProductGridContainer(
      html
    );

    FacetFiltersForm.renderProductCount(
      html
    );
  }

  static renderProductGridContainer(
    html
  ) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const source =
      parsedHTML.getElementById(
        'ProductGridContainer'
      );

    const target =
      document.getElementById(
        'ProductGridContainer'
      );

    if (!source || !target) {
      return;
    }

    target.innerHTML =
      source.innerHTML;
  }

  static renderProductCount(
    html
  ) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const sourceCount =
      parsedHTML.getElementById(
        'ProductCount'
      );

    const countContainer =
      document.getElementById(
        'ProductCount'
      );

    const countContainerDesktop =
      document.getElementById(
        'ProductCountDesktop'
      );

    if (
      !sourceCount ||
      !countContainer
    ) {
      return;
    }

    const count =
      sourceCount.innerHTML;

    countContainer.innerHTML =
      count;

    countContainer.classList.remove(
      'loading'
    );

    if (countContainerDesktop) {
      countContainerDesktop.innerHTML =
        count;

      countContainerDesktop.classList.remove(
        'loading'
      );
    }
  }

  static renderFilters(
    html,
    event
  ) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const facetDetailsElements =
      parsedHTML.querySelectorAll(
        '#FacetFiltersForm .js-filter, ' +
        '#FacetFiltersFormMobile .js-filter, ' +
        '#FacetFiltersPillsForm .js-filter'
      );

    const matchesIndex =
      (element) => {
        const jsFilter =
          event
            ? event.target.closest(
                '.js-filter'
              )
            : undefined;

        return jsFilter
          ? element.dataset.index ===
              jsFilter.dataset.index
          : false;
      };

    const facetsToRender =
      Array.from(
        facetDetailsElements
      ).filter(
        (element) =>
          !matchesIndex(element)
      );

    const countsToRender =
      Array.from(
        facetDetailsElements
      ).find(
        matchesIndex
      );

    facetsToRender.forEach(
      (element) => {
        const target =
          document.querySelector(
            `.js-filter[data-index="${element.dataset.index}"]`
          );

        if (target) {
          target.innerHTML =
            element.innerHTML;
        }
      }
    );

    FacetFiltersForm.renderActiveFacets(
      parsedHTML
    );

    FacetFiltersForm.renderAdditionalElements(
      parsedHTML
    );

    if (
      countsToRender &&
      event
    ) {
      const target =
        event.target.closest(
          '.js-filter'
        );

      if (target) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          target
        );
      }
    }
  }

  static renderActiveFacets(
    html
  ) {
    const activeFacetElementSelectors =
      [
        '.active-facets-mobile',
        '.active-facets-desktop'
      ];

    activeFacetElementSelectors.forEach(
      (selector) => {
        const activeFacetsElement =
          html.querySelector(
            selector
          );

        const target =
          document.querySelector(
            selector
          );

        if (
          !activeFacetsElement ||
          !target
        ) {
          return;
        }

        target.innerHTML =
          activeFacetsElement.innerHTML;
      }
    );

    FacetFiltersForm.toggleActiveFacets(
      false
    );
  }

  static renderAdditionalElements(
    html
  ) {
    const mobileElementSelectors =
      [
        '.mobile-facets__open',
        '.sorting'
      ];

    mobileElementSelectors.forEach(
      (selector) => {
        const sourceElement =
          html.querySelector(
            selector
          );

        const targetElement =
          document.querySelector(
            selector
          );

        if (
          !sourceElement ||
          !targetElement
        ) {
          return;
        }

        targetElement.innerHTML =
          sourceElement.innerHTML;
      }
    );

    /*
      Refresh the custom active-filter
      chips inside the drawer.
    */
    const sourceChips =
      html.getElementById(
        'MobileFacetsActiveChips'
      );

    const targetChips =
      document.getElementById(
        'MobileFacetsActiveChips'
      );

    if (
      sourceChips &&
      targetChips
    ) {
      targetChips.innerHTML =
        sourceChips.innerHTML;

      targetChips.hidden =
        sourceChips.hidden;
    }

    /*
      Re-bind the drawer after Shopify
      replaces facet markup.
    */
    const mobileForm =
      document.getElementById(
        'FacetFiltersFormMobile'
      );

    const menuDrawer =
      mobileForm
        ? mobileForm.closest(
            'menu-drawer'
          )
        : null;

    if (
      menuDrawer &&
      typeof menuDrawer.bindEvents ===
        'function'
    ) {
      menuDrawer.bindEvents();
    }
  }

  static renderCounts(
    source,
    target
  ) {
    const targetElement =
      target.querySelector(
        '.facets__selected'
      );

    const sourceElement =
      source.querySelector(
        '.facets__selected'
      );

    const targetElementAccessibility =
      target.querySelector(
        '.facets__summary'
      );

    const sourceElementAccessibility =
      source.querySelector(
        '.facets__summary'
      );

    if (
      sourceElement &&
      targetElement
    ) {
      targetElement.outerHTML =
        sourceElement.outerHTML;
    }

    if (
      targetElementAccessibility &&
      sourceElementAccessibility
    ) {
      targetElementAccessibility.outerHTML =
        sourceElementAccessibility.outerHTML;
    }
  }

  static updateURLHash(
    searchParams
  ) {
    history.pushState(
      {
        searchParams
      },
      '',
      `${window.location.pathname}${
        searchParams
          ? `?${searchParams}`
          : ''
      }`
    );
  }

  static getSections() {
    const productGrid =
      document.getElementById(
        'product-grid'
      );

    if (!productGrid) {
      return [];
    }

    return [
      {
        section:
          productGrid.dataset.id
      }
    ];
  }

  createSearchParams(
    form
  ) {
    const formData =
      new FormData(
        form
      );

    return new URLSearchParams(
      formData
    ).toString();
  }

  onSubmitForm(
    searchParams,
    event
  ) {
    FacetFiltersForm.renderPage(
      searchParams,
      event
    );
  }

  onSubmitHandler(
    event
  ) {
    event.preventDefault();

    const sortFilterForms =
      document.querySelectorAll(
        'facet-filters-form form'
      );

    if (
      event.srcElement.className ===
      'mobile-facets__checkbox'
    ) {
      const form =
        event.target.closest(
          'form'
        );

      if (!form) return;

      const searchParams =
        this.createSearchParams(
          form
        );

      this.onSubmitForm(
        searchParams,
        event
      );

      return;
    }

    const forms = [];

    const currentForm =
      event.target.closest(
        'form'
      );

    if (!currentForm) {
      return;
    }

    const isMobile =
      currentForm.id ===
      'FacetFiltersFormMobile';

    sortFilterForms.forEach(
      (form) => {
        if (!isMobile) {
          if (
            form.id ===
              'FacetSortForm' ||
            form.id ===
              'FacetFiltersForm' ||
            form.id ===
              'FacetSortDrawerForm'
          ) {
            forms.push(
              this.createSearchParams(
                form
              )
            );
          }
        } else if (
          form.id ===
          'FacetFiltersFormMobile'
        ) {
          forms.push(
            this.createSearchParams(
              form
            )
          );
        }
      }
    );

    this.onSubmitForm(
      forms.join('&'),
      event
    );
  }

  onActiveFilterClick(
    event
  ) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const href =
      event.currentTarget.href;

    const url =
      href.indexOf('?') === -1
        ? ''
        : href.slice(
            href.indexOf('?') + 1
          );

    FacetFiltersForm.renderPage(
      url
    );
  }
}

FacetFiltersForm.filterData =
  [];

FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(1);

FacetFiltersForm.searchParamsPrev =
  window.location.search.slice(1);

customElements.define(
  'facet-filters-form',
  FacetFiltersForm
);

FacetFiltersForm.setListeners();


class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll(
      'input'
    ).forEach(
      (element) =>
        element.addEventListener(
          'change',
          this.onRangeChange.bind(
            this
          )
        )
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(
    event
  ) {
    this.adjustToValidValues(
      event.currentTarget
    );

    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs =
      this.querySelectorAll(
        'input'
      );

    const minInput =
      inputs[0];

    const maxInput =
      inputs[1];

    if (
      !minInput ||
      !maxInput
    ) {
      return;
    }

    if (
      maxInput.value
    ) {
      minInput.setAttribute(
        'max',
        maxInput.value
      );
    }

    if (
      minInput.value
    ) {
      maxInput.setAttribute(
        'min',
        minInput.value
      );
    }

    if (
      minInput.value === ''
    ) {
      maxInput.setAttribute(
        'min',
        0
      );
    }

    if (
      maxInput.value === ''
    ) {
      minInput.setAttribute(
        'max',
        maxInput.getAttribute(
          'max'
        )
      );
    }
  }

  adjustToValidValues(
    input
  ) {
    const value =
      Number(
        input.value
      );

    const min =
      Number(
        input.getAttribute(
          'min'
        )
      );

    const max =
      Number(
        input.getAttribute(
          'max'
        )
      );

    if (
      value < min
    ) {
      input.value =
        min;
    }

    if (
      value > max
    ) {
      input.value =
        max;
    }
  }
}

customElements.define(
  'price-range',
  PriceRange
);


class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink =
      this.querySelector(
        'a'
      );

    if (!facetLink) return;

    facetLink.setAttribute(
      'role',
      'button'
    );

    facetLink.addEventListener(
      'click',
      this.closeFilter.bind(
        this
      )
    );

    facetLink.addEventListener(
      'keyup',
      (event) => {
        if (
          event.code.toUpperCase() ===
          'SPACE'
        ) {
          event.preventDefault();

          this.closeFilter(
            event
          );
        }
      }
    );
  }

  closeFilter(
    event
  ) {
    event.preventDefault();

    const form =
      this.closest(
        'facet-filters-form'
      ) ||
      document.querySelector(
        'facet-filters-form'
      );

    /*
      Normally this will always use
      the AJAX facet handler.

      If the surrounding form isn't
      available for any reason, fall
      back to the link URL so a filter
      can never become impossible to
      remove.
    */
    if (
      !form ||
      typeof form.onActiveFilterClick !==
        'function'
    ) {
      window.location.href =
        event.currentTarget.href;

      return;
    }

    form.onActiveFilterClick(
      event
    );
  }
}

customElements.define(
  'facet-remove',
  FacetRemove
);

document.addEventListener('click', (event) => {
  const applyButton = event.target.closest('[data-mobile-facets-apply]');

  if (!applyButton) return;

  const drawer = applyButton.closest('.mobile-facets__wrapper');
  const drawerSummary = drawer?.querySelector('.mobile-facets__open-wrapper');

  if (drawerSummary) {
    drawerSummary.click();
  }

  window.setTimeout(() => {
    const productGrid =
      document.getElementById('ProductGridContainer') ||
      document.getElementById('product-grid');

    if (!productGrid) return;

    productGrid.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, 180);
});